import React from 'react';
import { Dashboard } from '../../components/Dashboard';
import { PAGES, ROUTES } from './AdditionalFunctionalities.config';
import { useAuthentication } from '../../hooks/useAuthentication';
import styles from './AdditionalFunctionalities.styles.scss';
const AdditionalFunctionalities = () => {
  const { hasRole } = useAuthentication();

  return (
    <Dashboard
      isEInvoicing={true}
      pages={PAGES(hasRole)}
      routes={ROUTES}
      withBreadcrumb={true}
      tileId={'AdditionalFunctionalities'}
      wrapperClassName={styles.wrapper}
    />
  );
};

export default React.memo(AdditionalFunctionalities);
